import React from 'react'
import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  ToTopOutlined
} from '@ant-design/icons'
import { Modal } from 'hljd'
import store from './store'
import { EDIT_CASE_PATH_A } from '@constant'

const confirm = Modal.confirm

function showConfirm(id) {
  confirm({
    title: '是否移除该关联客照',
    onOk() {
      store.cancelRelation(id)
    },
    onCancel() {}
  })
}

export default [
  {
    title: '封面图',
    key: 'case_head_img',
    render: (text, record) => (
      <img className="table-img" src={record.work_info.cover_path} />
    )
  },
  {
    title: '客照名称',
    key: 'title',
    render: (text, record) => (
      <div>{record.work_info.title ? record.work_info.title : '-'}</div>
    )
  },
  {
    title: '排序',
    dataIndex: 'rating',
    key: 'rating',
    render: (text, record, index) => {
      return (
        <div className="table-sort-btn">
          <ArrowUpOutlined
            className={index === 0 ? 'ban' : ''}
            onClick={() => store.reOrder(index)}
          />
          <ArrowDownOutlined
            className={index + 1 === store.len ? 'ban' : ''}
            onClick={() => store.reOrder(index, 'desc')}
          />
          <ToTopOutlined
            className={index === 0 ? 'ban' : ''}
            onClick={() => store.reOrder(index, 'top')}
          />
        </div>
      )
    }
  },
  {
    title: '操作',
    key: 'ope',
    render: (text, record) => {
      const url = `${EDIT_CASE_PATH_A}/${record.work_id}?propertyId=6`
      return (
        <div>
          <a href={url} target="_blank" rel="noopener noreferrer">
            编辑客照
          </a>
          <a
            href="javascript:;"
            style={{ marginLeft: '10px' }}
            onClick={() => showConfirm(record.work_id)}
          >
            移除
          </a>
        </div>
      )
    }
  }
]
